var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      on: {
        mouseover: function($event) {
          _vm.hovered = true
        },
        mouseout: function($event) {
          _vm.hovered = false
        }
      }
    },
    [
      _c("div", {
        staticClass: "background",
        class: _vm.flixel.width > _vm.flixel.height ? "landscape" : "portrait",
        style: { backgroundImage: "url(" + _vm.flixel.thumbnail + ")" }
      }),
      _c("a", {
        staticClass: "hide-desktop link_overlay",
        on: {
          click: function($event) {
            _vm.goToFlixel(_vm.flixel.hash, _vm.flixels, _vm.index)
          }
        }
      }),
      _c("a", {
        staticClass: "hide-mobile link_overlay",
        on: {
          click: function($event) {
            _vm.goToFlixel(_vm.flixel.hash, _vm.flixels, _vm.index)
          }
        }
      }),
      _vm.hovered
        ? _c("iframe", {
            attrs: { src: _vm.flixel.player_url, allow: "autoplay" }
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f74e62f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f74e62f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FlixelListProfile.vue
// module id = null
// module chunks = 